import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  KitActionTypes,
  ActionKitStatusSubmit,
  ActionKitStatusSubmitSuccess,
  ActionKitStatusSubmitError,
  ActionKitActivateSubmit,
  ActionKitActivateSubmitSuccess,
  ActionKitActivateSubmitError
} from './types';
import { KitActivateFormPayload, KitResponse } from '../../models/kit';
import KitService from './effects';
import { APIError, ErrorResponse } from '../../helpers/types';
import { actionGetBarcodeDetails } from '../barcode/action';

export const dispatchKitStatusSubmit = (): ActionKitStatusSubmit => {
  return {
    type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT,
  };
};

export const dispatchKitStatusSubmitSuccess = (payload: KitResponse): ActionKitStatusSubmitSuccess => {
  return {
    type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT_SUCCESS,
    payload,
  };
};

export const dispatchKitStatusSubmitError = (e: APIError): ActionKitStatusSubmitError => {
  return {
    type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT_ERROR,
    error: e,
  };
};

export const dispatchKitActivateSubmit = (payload: KitActivateFormPayload): ActionKitActivateSubmit => {
  return {
    type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT,
    payload,
  };
};

export const dispatchKitActivateSubmitSuccess = (): ActionKitActivateSubmitSuccess => {
  return {
    type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_SUCCESS,
  };
};

export const dispatchKitActivateSubmitError = (e: APIError): ActionKitActivateSubmitError => {
  return {
    type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_ERROR,
    error: e,
  };
};
// Action Creators
export const actionGetKitStatus = () => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchKitStatusSubmit());
    return KitService.getKitStatus().then((result) => {
      const testHistory = result[0].test[0].history;
      result[0].history = result[0].history.concat(testHistory);
      return dispatch(dispatchKitStatusSubmitSuccess(result[0] as KitResponse));
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchKitStatusSubmitError(e.response));
    });
  };
};

export const actionActivateKit = (payload: KitActivateFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchKitActivateSubmit(payload));
    return KitService.activateKit(payload).then(async () => {
      await dispatch(actionGetBarcodeDetails({ barcode: payload.code }));
      return dispatch(dispatchKitActivateSubmitSuccess());
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchKitActivateSubmitError(e.response));
    });
  };
};
